import React from 'react';

const HeroSection: React.FC = () => {
  const scrollToEnrollment = () => {
    const element = document.getElementById('enrollment');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen bg-white flex flex-col">
      {/* Banner de Becas - MUCHO MÁS GRANDE */}
      <div className="w-full bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400 py-8 px-6 shadow-xl">
        <div className="max-w-7xl mx-auto flex flex-col items-center justify-center gap-4">
          <div className="flex items-center gap-4">
            <i className="ri-gift-line text-5xl text-gray-900 animate-pulse"></i>
            <div className="text-center">
              <p className="text-gray-900 font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight">
                ¡BECAS LIMITADAS DE 1.800€ DISPONIBLES!
              </p>
              <p className="text-gray-800 font-semibold text-xl md:text-2xl mt-2">
                Plazas limitadas - ¡No dejes pasar esta oportunidad!
              </p>
            </div>
            <i className="ri-gift-line text-5xl text-gray-900 animate-pulse"></i>
          </div>
        </div>
      </div>

      <div className="flex-1 flex flex-col py-8 px-6">
        {/* Header con logo */}
        <header className="w-full max-w-7xl mx-auto mb-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/629c9343645c6844591b8b96cb81f5f4/436f26973100798f101a5cb002f461bc.png"
                alt="Auxiliar Técnico Veterinario - Logo"
                className="h-16 w-auto mr-4"
              />
              <div>
                <h2 className="text-xl font-bold text-gray-900">Auxiliar Técnico Veterinario</h2>
                <p className="text-sm text-teal-600">Formación Profesional Online</p>
              </div>
            </div>
            <div className="flex items-center text-gray-700">
              <i className="ri-phone-line text-teal-500 mr-2"></i>
              <span className="font-semibold">967 615 226</span>
            </div>
          </div>
        </header>

        {/* Contenido principal */}
        <div className="flex-1 flex items-center">
          <div className="max-w-7xl mx-auto w-full">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              {/* Contenido Izquierdo */}
              <div className="flex-1 lg:max-w-xl">
                <div className="inline-flex items-center px-4 py-2 bg-teal-500/10 text-teal-600 rounded-full text-sm font-medium mb-6">
                  <i className="ri-graduation-cap-line mr-2"></i>
                  Formación Profesional Online
                </div>
                
                <h1 className="text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-6">
                  Convierte tu pasión<br />
                  por los animales{' '}
                  <span className="text-teal-500">en tu profesión</span>
                </h1>
                
                <p className="text-xl lg:text-2xl text-gray-600 mb-8 leading-relaxed">
                  Formación completa y flexible para trabajar en clínicas veterinarias
                </p>
                
                <button 
                  onClick={scrollToEnrollment}
                  className="inline-flex items-center px-8 py-4 bg-teal-500 text-white font-bold text-lg rounded-full hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  Matricularme ahora
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
                
                <div className="flex items-center text-gray-500 mt-4 text-sm">
                  <div className="flex items-center mr-6">
                    <i className="ri-check-line text-teal-500 mr-1"></i>
                    Acceso inmediato
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-teal-500 mr-1"></i>
                    Estudia a tu ritmo
                  </div>
                </div>
              </div>
              
              {/* Imagen Derecha */}
              <div className="flex-1 relative">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/a8fb510f10282be867b8cc101a4a4f22.jpg"
                    alt="Veterinario profesional con mascota"
                    className="w-full h-auto object-cover"
                  />
                  <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-teal-500/20 to-transparent rounded-bl-3xl"></div>
                </div>
                
                {/* Tarjeta flotante de testimonios */}
                <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-xl border border-gray-100">
                  <div className="flex items-center">
                    <div className="flex text-yellow-400 mr-2">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm"></i>
                      ))}
                    </div>
                    <span className="font-semibold text-gray-900">4.9/5</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">Más de 500 alumnos formados</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
